import Vue from "vue";
import vuex, { Store } from "vuex";
import helloWorld from "./helloworld";
import editorControl from "./editor";
import contents from "./content";
import wycContent from "./wycContent";
import sucaiSearch from "./sucaiSearch";
import material from "./material";
import api from "./api";
import data from "./data";
import hotList from "./hotList";
import home from "./home";
import user from "./user";
import style from "./style";

Vue.use(vuex);
/**
 * 返回工厂模式
 * @returns {Store<>}
 */

const store = new Store({
  modules: {
    data,
    api,
    helloWorld,
    editorControl,
    contents,
    wycContent,
    sucaiSearch,
    material,
    hotList,
    home,
    user,
    style
  }
});

export default store;
